import axios from 'axios';
import { axiosInstance } from '../Axios';
import {
	loader,
	storeData,
	toggleErrorModal,
	setErrorMessage,
} from './UiReducer';
import {
	flightBalanceEtravDispatch,
	flightPaymentDebitEtravDispatch,
	flightTicketEtravDispatch,
} from './EtravReducer';
const { createSlice } = require('@reduxjs/toolkit');

const HomeReducer = createSlice({
	name: 'home',
	initialState: {
		success: false,
		error: null,
		loading: false,
		city: null,
		onewayflightdata: null,
		onewayflightdataEtrav: null,
		flightBook: null,
		flightBookEtrav: null,
		flightreturn: null,
		fareRule: null,
		fareRuleEtrav: null,
		fareQuote: null,
		fareQuoteEtrav: null,
		ticketGDS: null,
		releasePNR: null,
		flightLCCTicket: null,
		bookingDetail: null,
		flightCancel: null,
		cancelStatus: null,
		cancellationCharge: null,
		SSREtrav: null,
		SeatMEtrav: null,
		roundTripEtrav: null,
	},
	reducers: {
		cityRequest(state, action) {
			state.loading = true;
		},
		citySuccess(state, action) {
			state.loading = false;
			state.city = action.payload;
			state.error = null;
		},
		cityFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		SSREtravRequest(state, action) {
			state.loading = true;
		},
		SSREtravSuccess(state, action) {
			state.loading = false;
			state.SSREtrav = action.payload;
			state.error = null;
		},
		SSrEtravFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		fareRuleRequest(state, action) {
			state.loading = true;
		},
		fareRuleSuccess(state, action) {
			state.loading = false;
			state.fareRule = action.payload;
			state.error = null;
		},
		fareRuleFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		fareRuleEtravRequest(state, action) {
			state.loading = true;
		},
		fareRuleEtravSuccess(state, action) {
			state.loading = false;
			state.fareRuleEtrav = action.payload;
			state.error = null;
		},
		fareRuleEtravFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		SeatMEtravRequest(state, action) {
			state.loading = true;
		},
		SeatMEtravSuccess(state, action) {
			state.loading = false;
			state.SeatMEtrav = action.payload;
			state.error = null;
		},
		SeatMEtravFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		fareQuoteRequest(state, action) {
			state.loading = true;
		},
		fareQuoteSuccess(state, action) {
			state.loading = false;
			state.fareQuote = action.payload;
			state.error = null;
		},
		fareQuoteFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		fareQuoteEtravRequest(state, action) {
			state.loading = true;
		},
		fareQuoteEtravSuccess(state, action) {
			state.loading = false;
			state.fareQuoteEtrav = action.payload;
			state.error = null;
		},
		fareQuoteEtravFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		ticketGDSRequest(state, action) {
			state.loading = true;
		},
		ticketGDSSuccess(state, action) {
			state.loading = false;
			state.ticketGDS = action.payload;
			state.error = null;
		},
		ticketGDSFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		bookingDetailRequest(state, action) {
			state.loading = true;
		},
		bookingDetailSuccess(state, action) {
			state.loading = false;
			state.bookingDetail = action.payload;
			state.error = null;
		},
		bookingDetailFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		searchRequest(state, action) {
			state.loading = true;
		},
		searchSuccess(state, action) {
			state.loading = false;
			state.onewayflightdata = action.payload;
			state.error = null;
		},
		searchSuccessEtrav(state, action) {
			state.loading = false;
			state.onewayflightdataEtrav = action.payload;
			state.error = null;
		},
		searchSuccessRoundEtrav(state, action) {
			state.loading = false;
			state.roundTripEtrav = action.payload;
			state.error = null;
		},
		searchFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		searchReturnRequest(state, action) {
			state.loading = true;
		},
		searchReturnSuccess(state, action) {
			state.loading = false;
			state.flightreturn = action.payload;
			state.error = null;
		},
		searchReturnFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		flightBookRequest(state, action) {
			state.loading = true;
		},
		flightBookSuccess(state, action) {
			state.loading = false;
			state.flightBook = action.payload;
			state.error = null;
		},
		flightBookFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		flightBookEtravRequest(state, action) {
			state.loading = true;
		},
		flightBookEtravSuccess(state, action) {
			state.loading = false;
			state.flightBookEtrav = action.payload;
			state.error = null;
		},
		flightBookEtravFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		flightLCCRequest(state, action) {
			state.loading = true;
		},
		flightLCCSuccess(state, action) {
			state.loading = false;
			state.flightLCCTicket = action.payload;
			state.error = null;
		},
		flightLCCFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		releasePNRRequest(state, action) {
			state.loading = true;
		},
		releasePNRSuccess(state, action) {
			state.loading = false;
			state.releasePNR = action.payload;
			state.error = null;
		},
		releasePNRFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		flightCancelRequest(state, action) {
			state.loading = true;
		},
		flightCancelSuccess(state, action) {
			state.loading = false;
			state.flightCancel = action.payload;
			state.error = null;
		},
		flightCancelFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		flightCancelStatusRequest(state, action) {
			state.loading = true;
		},
		flightCancelStatusSuccess(state, action) {
			state.loading = false;
			state.cancelStatus = action.payload;
			state.error = null;
		},
		flightCancelStatusFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		cancellationChargeRequest(state, action) {
			state.loading = true;
		},
		cancellationChargeSuccess(state, action) {
			state.loading = true;
			state.cancellationCharge = action.payload;
			state.error = null;
		},
		cancellationChargeFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = HomeReducer;

export const {
	cityRequest,
	citySuccess,
	cityFail,
	fareRuleRequest,
	fareRuleSuccess,
	fareRuleFail,
	fareRuleEtravRequest,
	fareRuleEtravSuccess,
	fareRuleEtravFail,
	fareQuoteRequest,
	fareQuoteSuccess,
	fareQuoteFail,
	fareQuoteEtravRequest,
	fareQuoteEtravSuccess,
	fareQuoteEtravFail,
	searchRequest,
	searchSuccess,
	searchSuccessEtrav,
	searchSuccessRoundEtrav,
	searchFail,
	flightBookRequest,
	flightBookSuccess,
	flightBookFail,
	flightBookEtravRequest,
	flightBookEtravSuccess,
	flightBookEtravFail,
	flightLCCRequest,
	flightLCCSuccess,
	flightLCCFail,
	searchReturnRequest,
	searchReturnSuccess,
	searchReturnFail,
	ticketGDSRequest,
	ticketGDSSuccess,
	ticketGDSFail,
	bookingDetailRequest,
	bookingDetailSuccess,
	bookingDetailFail,
	releasePNRRequest,
	releasePNRSuccess,
	releasePNRFail,
	flightCancelRequest,
	flightCancelSuccess,
	flightCancelFail,
	flightCancelStatusRequest,
	flightCancelStatusSuccess,
	flightCancelStatusFail,
	cancellationChargeRequest,
	cancellationChargeSuccess,
	cancellationChargeFail,
	SSREtravRequest,
	SSREtravSuccess,
	SSREtravFail,
	SeatMEtravRequest,
	SeatMEtravSuccess,
	SeatMEtravFail,
} = actions;

export const fetchCityDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(cityRequest());
		const config = {
			headers: {
				'Content-Type': 'application/json',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
			},
		};
		const { data } = await axiosInstance.post(
			'home/flightairport',
			bodyData,
			config
		);
		console.log(data);
		// setResult(data);
		dispatch(citySuccess(data));
	} catch (error) {
		dispatch(toggleErrorModal(true));
		dispatch(
			setErrorMessage(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
		dispatch(
			cityFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const SearchFormDispatch =
	(bodyData, history, OriginO, des, origin) => async (dispatch) => {
		try {
			dispatch(searchRequest());
			history.push({
				pathname: '/oneway',
				state: {
					body: bodyData,
					OriginO: OriginO,
				},
			});
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'flytbo/flightsearch',
				bodyData,
				config
			);
			// 'file/FLIGHT-ETR/FlyEtrav/flightsearch',
			const etrav = await axiosInstance.post(
				'FlyEtrav/flightsearch',
				bodyData,
				config
			);

			dispatch(searchSuccess(data));
			dispatch(searchSuccessEtrav(etrav.data));
			// history.push({

			// });
		} catch (error) {
			dispatch(toggleErrorModal(true));
			dispatch(
				setErrorMessage(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
			dispatch(
				searchFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const SearchReturnFormDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(searchReturnRequest());
			history.push('/roundway');
			dispatch(loader(true));
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'flytbo/flightsearch',
				bodyData,
				config
			);
			const etrav = await axiosInstance.post(
				'FlyEtrav/flightsearch',
				bodyData,
				config
			);
			dispatch(searchReturnSuccess(data));
			dispatch(searchSuccessRoundEtrav(etrav.data));
			history.push({
				pathname: '/roundway',
				state: { RData: etrav.data, returnBody: bodyData },
			});
			storeData('return', etrav.data);
			dispatch(loader(false));
		} catch (error) {
			dispatch(loader(false));
			dispatch(
				searchReturnFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightFareRuleDispatch =
	(ResultIndex, TraceId) => async (dispatch) => {
		try {
			let bodyData = {
				TraceId: TraceId,
				ResultIndex: ResultIndex,
			};
			// dispatch(fareRuleRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flightfarerule',
				bodyData,
				config
			);

			console.log(data);
			dispatch(fareRuleSuccess(data));
		} catch (error) {
			dispatch(
				fareRuleFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};

export const FlightFareRuleEtravDispatch =
	(Search_Key, Flight_Key, Fare_Id) => async (dispatch) => {
		try {
			let formData = {
				Search_Key: Search_Key,
				Flight_Key: Flight_Key,
				Fare_Id: Fare_Id,
			};
			// dispatch(fareRuleEtravRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyEtrav/flightfarerule',
				formData,
				config
			);

			console.log(data);
			dispatch(fareRuleEtravSuccess(data));
			if (data.status === 202) {
				dispatch(toggleErrorModal(true));
				dispatch(setErrorMessage(data.message));
			}
		} catch (error) {
			dispatch(toggleErrorModal(true));
			dispatch(
				setErrorMessage(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
			dispatch(
				fareRuleFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightFareQuoteDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(fareQuoteRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
				'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
			},
		};
		const { data } = await axiosInstance.post(
			'FlyTbo/flightfarequote',
			bodyData,
			config
		);
		// const { data } = await axiosInstance.get(
		// 	`/app/api/flight-fare-quote?TraceId=${TraceId}&ResultIndex=${rI}`
		// );
		console.log(data);
		dispatch(fareQuoteSuccess(data));

		// dispatch(loader(false));
	} catch (error) {
		dispatch(toggleErrorModal(true));
		dispatch(
			setErrorMessage(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
		dispatch(
			fareQuoteFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const FlightFareQuoteEtravDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(fareQuoteEtravRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
				'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
			},
		};
		const { data } = await axiosInstance.post(
			'FlyEtrav/flightreprice',
			bodyData,
			config
		);
		console.log(data);
		dispatch(fareQuoteEtravSuccess(data));
		dispatch(flightBalanceEtravDispatch());
		if (data.status === 202) {
			dispatch(toggleErrorModal(true));
			dispatch(setErrorMessage(data.message));
		}
	} catch (error) {
		dispatch(toggleErrorModal(true));
		dispatch(
			setErrorMessage(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
		dispatch(
			fareQuoteEtravFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const FlightBookDispatch =
	(bodyData, history, TraceId) => async (dispatch) => {
		try {
			dispatch(flightBookRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flightbook',
				bodyData,
				config
			);

			dispatch(flightBookSuccess(data));

			console.log(data.result.Response.Response);
			if (data.result.Response.Response) {
				let formData = {
					TraceId: TraceId,
					PNR: data.result.Response.Response.PNR,
					BookingId: data.result.Response.Response.BookingId,
				};
				dispatch(FlightTicketGDSDispatch(formData, history));
			}
			// if (data.data) {
			// 	dispatch(
			// 		FlightTicketDispatch(
			// 			TraceId,
			// 			data.data.Response.Response.PNR,
			// 			data.data.Response.Response.BookingId
			// 		)
			// 	);
			// 	history.push('/ticket');
			// 	dispatch(
			// 		FlightBookingDetailDispatch(
			// 			data.data.Response.Response.PNR,
			// 			data.data.Response.Response.BookingId
			// 		)
			// 	);
			// }
			// alert(
			// 	data.Response
			// 		? data.Response.Error.ErrorMessage
			// 		: 'Ticket Generate Successfully'
			// );

			console.log('Ticket');
			// }
		} catch (error) {
			dispatch(toggleErrorModal(true));
			dispatch(loader(false));
			dispatch(
				flightBookFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightSSREtravDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(SSREtravRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
				'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
			},
		};
		const { data } = await axiosInstance.post(
			'FlyEtrav/specialservicerequest',
			bodyData,
			config
		);
		console.log(data);
		dispatch(SSREtravSuccess(data));
	} catch (error) {
		dispatch(
			SSREtravFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const FlightSeatMapEtravDispatch = (bodyData) => async (dispatch) => {
	try {
		dispatch(SeatMEtravRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
				'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
			},
		};
		const { data } = await axiosInstance.post(
			'FlyEtrav/flightseatmap',
			bodyData,
			config
		);
		console.log(data);
		dispatch(SeatMEtravSuccess(data));
	} catch (error) {
		dispatch(
			SeatMEtravFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};
export const FlightBookEtravDispatch =
	(bodyData, history, payment, states) => async (dispatch) => {
		try {
			dispatch(flightBookEtravRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyEtrav/flightbooking',
				bodyData,
				config
			);

			dispatch(flightBookEtravSuccess(data));
			if (data.status === 200 && data.result.Booking_RefNo) {
				// if (payment === 'offline') {
				// let ticketData = {
				// 	Booking_RefNo: data.result.Booking_RefNo,
				// 	Ticketing_Type: '1',
				// };
				let payment = {
					ProductId: '1',
					RefNo: data.result.Booking_RefNo,
					TransactionType: '0',
				};
				dispatch(
					flightPaymentDebitEtravDispatch(
						payment,
						data.result.Booking_RefNo,
						history,
						states
					)
				);
				// dispatch(flightTicketEtravDispatch(ticketData, history));
				// }
			} else {
				dispatch(toggleErrorModal(true));
				dispatch(
					setErrorMessage(data.result.Response_Header.Error_InnerException)
				);
			}
		} catch (error) {
			dispatch(
				flightBookEtravFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightTicketLCCDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(flightLCCRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flightticketlcc',
				bodyData,
				config
			);

			dispatch(flightLCCSuccess(data));
			// dispatch(loader(false));
			console.log(data.data);
			if (data.status === 200) {
				history.push('/ticket');
				// alert('This is Lcc Ticket');
			} else {
				dispatch(toggleErrorModal(true));
				dispatch(setErrorMessage(data.message));
			}

			console.log('Ticket');
			// }
		} catch (error) {
			dispatch(loader(false));
			dispatch(
				flightLCCFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightTicketGDSDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(ticketGDSRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flightticketgds',
				bodyData,
				config
			);
			console.log(data);
			dispatch(ticketGDSSuccess(data));
			if (data.status === 200) {
				history.push('/ticket');
				// alert('This is Non-Lcc Ticket');
			} else {
				dispatch(toggleErrorModal(true));
				dispatch(setErrorMessage(data.message));
			}
		} catch (error) {
			dispatch(toggleErrorModal(true));
			dispatch(
				ticketGDSFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightBookingDetailDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(bookingDetailRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flightbookingdetails',
				bodyData,
				config
			);
			console.log(data);
			dispatch(bookingDetailSuccess(data));
			dispatch(loader(false));
		} catch (error) {
			dispatch(loader(false));
			dispatch(
				bookingDetailFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};
export const FlightReleasePNRDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(releasePNRRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flightreleasepnr',
				bodyData,
				config
			);
			console.log(data);
			dispatch(releasePNRSuccess(data));
			dispatch(loader(false));
		} catch (error) {
			dispatch(loader(false));
			dispatch(
				releasePNRFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};

export const FlightCancelDispatch = (bodyData, history) => async (dispatch) => {
	try {
		dispatch(flightCancelRequest());
		const config = {
			headers: {
				Accept: 'application/json',
				'Content-Type': 'multipart/form-data',
				'Client-Service': 'srk-client',
				'Auth-Key': 'srkapi',
				'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
			},
		};
		const { data } = await axiosInstance.post(
			'FlyTbo/flighcancel',
			bodyData,
			config
		);
		console.log(data);
		dispatch(flightCancelSuccess(data));
	} catch (error) {
		dispatch(
			flightCancelFail(
				error.response && error.response.data.message
					? error.response.data.message
					: error.message
			)
		);
	}
};

export const FlightCancelStatusDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(flightCancelStatusRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flighcancelstatus',
				bodyData,
				config
			);
			console.log(data);
			dispatch(flightCancelStatusSuccess(data));
		} catch (error) {
			dispatch(
				flightCancelStatusFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};

export const FlightCancellationChargeDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(cancellationChargeRequest());
			const config = {
				headers: {
					Accept: 'application/json',
					'Content-Type': 'multipart/form-data',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
					'Api-Key': 'NjA4ZGFkYWQ2MjY4MA==',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyTbo/flighcancellationcharge',
				bodyData,
				config
			);
			console.log(data);
			dispatch(cancellationChargeSuccess(data));
		} catch (error) {
			dispatch(
				cancellationChargeFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};

export default HomeReducer;
